import LoginForm from './form';

export default LoginForm;